"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const utils_1 = require("./utils");
const ProfileAvatar = ({ datasetId }) => {
    var _a, _b, _c;
    const sharedWith = (0, react_redux_1.useSelector)((state) => dataset_shares_1.datasetSharesSelectors.getSharesByDatasetId(state, datasetId));
    const sharedWithList = (_c = (_a = sharedWith === null || sharedWith === void 0 ? void 0 : sharedWith.valueSeq) === null || _a === void 0 ? void 0 : (_b = _a.call(sharedWith)).toArray) === null || _c === void 0 ? void 0 : _c.call(_b);
    if (sharedWithList.length > 0) {
        const maxAvatars = 2;
        const visibleShares = sharedWithList.slice(0, maxAvatars);
        const extraCount = sharedWithList.length - maxAvatars;
        return (<Box_1.default display="inline-flex" alignItems="center">
        {visibleShares.map((share, index) => {
                var _a, _b, _c, _d, _e, _f;
                const fullName = `${(_b = (_a = share.granteeFirstName) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''} ${(_d = (_c = share.granteeLastName) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : ''}`.trim();
                const avatarProps = (0, utils_1.stringAvatar)(fullName);
                return (<Avatar_1.default key={(_f = (_e = share.id) !== null && _e !== void 0 ? _e : fullName) !== null && _f !== void 0 ? _f : index} {...avatarProps} sx={Object.assign(Object.assign({}, avatarProps.sx), { marginLeft: index === 0 ? '16px' : '4px' })}/>);
            })}
        {extraCount > 0 && (<Avatar_1.default sx={{
                    width: 28,
                    height: 28,
                    fontSize: 12,
                    marginLeft: '4px',
                    color: 'shadowGrey',
                    fontWeight: 500,
                }}>
            {`+${extraCount}`}
          </Avatar_1.default>)}
      </Box_1.default>);
    }
    return null;
};
exports.default = ProfileAvatar;
